<template>
    <div id="construcao" class="construcao-page">
        <Menu-component />
        <div class="container">
        <section class="background">
            <div class="content-wrapper">
                <div class="title-section">
                    <h2>O Monitoramento</h2>
                </div>
                <div class="content">
                    <div class="content-box-01">
                        <h3>O monitoramento é etapa fundamental em um ciclo de planejamento. </h3>
                        <p>Lançado em abril de 2019, o PNSH se consolidou como instrumento fundamental ao alcance de objetivos da Política Nacional de Recursos Hídricos, que estabelece a necessidade de assegurar, à atual e às futuras gerações, uma adequada disponibilidade de água e a prevenção contra eventos hidrológicos críticos.</p>
                        <p>Anualmente são publicados Boletins de Monitoramento do PNSH nos quais é possível conhecer o andamento de cada intervenção planejada, de acordo com o seu estágio de implementação apresentado no Caminho da Segurança Hídrica.</p>
                        <p>Esse acompanhamento é realizado pelo Núcleo de Segurança Hídrica (NSH), instituído pelo Ministério do Desenvolvimento Regional (MDR) por meio da Portaria nº 2.715, de 19 de novembro de 2019, em um ambiente colaborativo que tem como um de seus objetivos consolidar uma base de informações que favoreça o planejamento e o monitoramento de ações relacionadas à segurança hídrica.</p>
                    </div>
                    <div class="content-box-02">
                        <a href="https://www.gov.br/ana/pt-br/assuntos/seguranca-hidrica/plano-nacional-de-seguranca-hidrica/boletins-de-monitoramento-do-pnsh-1" target="_blank"><button>Acesse os boletins do PNSH<img src="@/assets/arrow-right.svg" alt=""></button></a>
                    </div>
                </div>
            </div>
        </section>
        
        </div>
    </div>

</template>

<script>
import Menu from '@/components/Menu'



export default {

  components: {
    'Menu-component': Menu
  },


  data () {
    return {
      eventoScroll: null,
      delta: null,
      ticking: false,
      scrollSensitivitySetting: 30,
      currentSlideNumber: 0,
      totalSlideNumber: null,
      slideDurationSetting: 600
    }
  },

  mounted () {
    this.totalSlideNumber = document.querySelectorAll('.background').length;
    this.previousItem()
    this.mousewhellevent();
  },

   destroyed () {
      window.removeEventListener('wheel', this.onMouseWheel);
   },

  methods: {

    mousewhellevent () {
      let screen = window.screen.width
      if (screen <= 1200) {
        return false
      }

       window.addEventListener('wheel', this.onMouseWheel);
    },

    onMouseWheel (evt) {
        this.eventoScroll = evt
        this.parallaxScroll(this.eventoScroll)
    },

    parallaxScroll (evt) {
      let isFirefox = (/Firefox/i.test(navigator.userAgent));
      let isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));

      if (isFirefox) {
        this.delta = evt.detail * (-120);
      } else if (isIe) {
        this.delta = -evt.deltaY;
      } else {
        this.delta = evt.wheelDelta;
      }

      if (this.ticking !== true) {
        if (this.delta <= -this.scrollSensitivitySetting) {
          this.ticking = true;

          if (this.currentSlideNumber !== this.totalSlideNumber - 1) {
            this.currentSlideNumber++;
            this.nextItem();
          }
          this.slideDurationTimeout(this.slideDurationSetting);
        }
        if (this.delta >= this.scrollSensitivitySetting) {
          this.ticking = true;
          if (this.currentSlideNumber !== 0) {
            this.currentSlideNumber--;
          }
          this.previousItem();
          this.slideDurationTimeout(this.slideDurationSetting);
        }
      }
    },

    nextItem () {
       var $previousSlide = document.querySelectorAll('.background')[this.currentSlideNumber - 1];
       $previousSlide.classList.remove('up-scroll')
       $previousSlide.classList.add('down-scroll');
    },

    next () {
        this.currentSlideNumber++;
        this.nextItem()
    },

    prev () {
        this.currentSlideNumber--;
        this.previousItem()
    },

    previousItem () {
      var $currentSlide = document.querySelectorAll('.background')[this.currentSlideNumber];
      $currentSlide.classList.remove('down-scroll')
      $currentSlide.classList.add('up-scroll');
    },

    slideDurationTimeout (slideDuration) {
      setTimeout(() => {
        this.ticking = false;
      }, slideDuration);
    }
  }
};
</script>


<style lang="scss" scoped>

.title-section{
  background-color: #ffffff;
  margin-bottom: 0px;
  padding-left: 0;
  h2 {
    @include media_tablet() {
      padding-left: 20px;
    }
  }
}

.container {
    padding-top: 70px;
    width: 1234px;
    @include media_tablet() {
        padding-top: 50px;
        width: 100%;
    }
}


.construcao-page {
    position: relative;
    &::after {
        content: '';
        background-image: url(../assets/assets-esquerda.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0px;
        height: 60vh;
        width: 10vh;
        @include media_tablet() {
          display: none;
        }
    }

    &::before {
        content: '';
        background-image: url(../assets/assets-direita.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 189px;
        right: 0px;
        height: 995px;
        width: 21vh;
        @include media_tablet() {
          display: none;
        }
    }
}

#construcao {
  .content-wrapper {
    h3 {
      padding-left: 0px;
      margin-bottom: 26px;

      @include media_tablet() {
        padding-left: 0;
      }
      @media (max-height:  900px) and (min-width: 1200px) {
        margin-bottom: 26px;
      }
    }

    .content {
      display: flex;
      background-color: #ffffff;

      @include media_tablet() {
        padding: 0 22px;
        flex-direction: column;
      }

      @media (max-height:  900px) and (min-width: 1200px)   {
        justify-content: center;
        margin-bottom: 240px;
        margin-top: 40px;
        overflow: auto;
      }

      .content-box-01 {
        width: 821px;
        line-height: 24px;
        h3 {
          font-size: 14px;
          width: 422px;
          @include media_tablet() {
            width: auto;
          }
        }
        p {
          margin-bottom: 30px;
        }

        @include media_tablet() {
          width: 100%;
        }

        @media (max-height:  900px) and (min-width: 1200px) {
            width: 30%;
        }
        img {
          max-width: 100%;
        }
      }
      .content-box-02 {
        background-color: #ffffff;
        padding-left: 25px;
        width: 420px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h3 {
          font-size: 14px;
          text-align: center;
          line-height: 1.57;
        }
        img {
          float: right;
          margin-right: 10px;
        }
        button {
          width: 290px;
          height: 46px;
          background-color: #3994d0;  
          border: none;
          border-radius: 30px;
          color: #ffffff;
          font-size: 15px;
          text-align: left;
          padding-left: 20px;
          font-family: 'rubik_mediumregular';
          margin-bottom: 12px;
          cursor: pointer;
        }
        @include media_tablet() {
          margin-top: 26px;
          padding: 0px;
          width: 100%;
          margin-bottom: 35px;
        }

        @media (max-height:  900px) and (min-width: 1200px) {
            width: 50%;
        }

        p {
          padding-left: 25px;
          line-height: 24px;

        @media (max-height:  900px) and (min-width: 1200px) {
            padding-left: 25px;
            line-height: 22px;
            font-size: 13px;
        }

          @include media_tablet() {
            padding: 0px;
          }

          &:nth-child(1) {
            margin-bottom: 30px;
            @media (max-height:  900px) and (min-width: 1200px) {
                margin-bottom: 16px;
                font-size: 13px;
            }
          }
        }
      }
    }

.section-2 {
  .content {
    display: flex;

    @include media_tablet() {
      flex-direction: column;
    }


    .content-box-01 {
        padding-top: 60px;
        padding-left: 120px;
        padding-right: 29px;
        width: 516px;

        @include media_tablet() {
            width: 100%;
            padding: 0;
            margin-top: 35px;
        }

        @media (max-height:  900px) and (min-width: 1200px)   {
            padding-top: 10px;
            padding-left: 0px;
            padding-right: 29px;
            width: 40%;
        }

        p {
          font-size: 14px;
          line-height: 24px;
          margin-bottom: 10px;
          @media (max-height:  900px) and (min-width: 1200px)   {
            font-size: 13px;
            line-height: 23px;
            margin-bottom: 0px;
          }
        }

        ul {
          p {
            margin-bottom: 5px;
          }
        }
      }
      .content-box-02 {
        width: 719px;

        @include media_tablet() {
          width: 100%;
        }

        @media (max-height:  900px) and (min-width: 1200px)   {
            width: 30%;
        }

        h3 {
          text-align: left;
          padding: 0px;
          @include media_tablet() {
            padding: 0 22px;
            margin: 21px 0;
          }
        }
        img {
          max-width: 100%;
          @include media_tablet() {
            padding: 0 22px;
          }
          @media (max-height:  900px) and (min-width: 1200px)   {
            max-width: 80%;
          }
        }

      }
}
    button {
          cursor: pointer;
          margin: 67px 0 0 auto;
          &::after {
            content: "";
            position: absolute;
            right: 70px;
            top: 17px;
            background-repeat: no-repeat;
            background-image: url(../assets/seta-direita-branca.svg);
            width: 9px;
            height: 14px;

            @include media_tablet() {
              top: 22px;
              right: 35px;
            }
          }

          @include media_tablet() {
            margin: 15px 0 0 0;
            width: 100%;
            border-radius: 30px 30px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media (max-height:  900px) and (min-width: 1200px)   {
                cursor: pointer;
                margin: 67px 0 0 auto;
                position: absolute;
                right: 20vw;
          }
        }
  }
  }
}



.navegacao {
    position: absolute;
    bottom: 22vh;
}
.navegacao-02 {
    position: absolute;
    bottom: 22vh;
}
</style>
